module.exports = __webpack_public_path__ + "static/media/unit 3-15.fb53b6ba.jpg";